import React, { useState } from "react";
import PointCutTableComponent from "./pointCutTable.component";
import { useDispatch, useSelector } from "react-redux";
import { getPointCut, resetPointCutDetails } from "modules/loyalty-program/redux";
import { setType } from "modules/loyalty-program/redux/slice/redemptionCenter.slice"
import { hideBackdrop, showBackdrop } from "modules/backdrop";
import { PointCutDialog } from "../../dialog";
import { unwrapResult } from '@reduxjs/toolkit'
import ConfirmationDialog from 'components/dialog/confirmation/confirmationDialog.component'
import { redemptionCenterType } from "modules/loyalty-program/constants";
import { getLang } from "app/feature/constants";

export default function GiftListTableContainer({
  hasPointCutAddAccessRight,
  hasPointCutEditAccessRight,
  hasPointCutActivateOrDeactivateAccessRight,
  data,
  isFetching,
  page,
  search,
  rowsPerPage,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
  handleCreate,
  handleStatusChange,
  handleReload,
  paginationOptions
}) {
  const dispatch = useDispatch()
  const [isModalOpen, setModalOpen] = useState(false);
  const [confirmationDialogModal] = useState(false);
  const isLoadingPointCutError = useSelector(
    (state) => state.redemptionCenter.isLoadingPointCutError
  );
  const lang = useSelector(state => state.constant.languages)
  const language = useSelector(state => state.profile.language)


  const handleView = (id) => {
    dispatch(setType({ index: redemptionCenterType.pointCut, type: "view" }));
    dispatch(showBackdrop());
    dispatch(getPointCut(id))
      .then(unwrapResult)
      .then(() => {
        dispatch(hideBackdrop())
        setModalOpen(true)
      })
  }

  const handleClose = () => {
    dispatch(resetPointCutDetails())
    setModalOpen(false);
  }

  return (
    <>
      <PointCutTableComponent
        hasPointCutAddAccessRight={hasPointCutAddAccessRight}
        hasPointCutEditAccessRight={hasPointCutEditAccessRight}
        hasPointCutActivateOrDeactivateAccessRight={hasPointCutActivateOrDeactivateAccessRight}
        data={data}
        isFetching={isFetching}
        page={page}
        search={search}
        language={language}
        rowsPerPage={rowsPerPage}
        totalRecords={totalRecords}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleCreate={handleCreate}
        handleView={handleView}
        handleStatusChange={handleStatusChange}
        handleReload={handleReload}
        isLoadingPointCutError={isLoadingPointCutError}
        paginationOptions={paginationOptions}
        lang={lang}
      />
      <PointCutDialog
        isOpen={isModalOpen}
        handleClose={handleClose}
      />
      <ConfirmationDialog
        isOpen={confirmationDialogModal}
        handleClose={handleClose}
        type="success"
        title={getLang(lang,"label.GIFT_ADDED_SUCCESSFULLY")}
        rejectOption={false}
        proceedLabel={getLang(lang,"label.ALRIGHT")}
      />
    </>
  );
}
